export default __webpack_public_path__ + "static/media/mamut_l1.9551655f.png";